import { Box, Button, Grid } from "@mui/material";
import ImageAttachments from "./ImageAttachments";

// Bottom row of the form: attaching images and the send button
const AttachmentsAndSubmit = (props) => {
  const { formData, handleSave, isSubmitting } = props;

  return (
    <Grid item xs={12}>
      <Box
        sx={{
          display: "flex",
          gap: 2,
          justifyContent: "space-between",
          alignItems: "flex-start",
        }}
      >
        <ImageAttachments {...props} />
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#006699",
            borderRadius: "8px",
            padding: "8px 24px",
            fontFamily: "Rubik, sans-serif",
            fontWeight: 500,
            "&.Mui-disabled": {
              color: "#333333", // Dark grey color
            },
          }}
          onClick={handleSave}
          disabled={isSubmitting || !formData.termsAccepted}
        >
          {isSubmitting ? "שולח..." : "אישור"}
        </Button>
      </Box>
    </Grid>
  );
};

export default AttachmentsAndSubmit;
